<script>
    import { sgettext } from '../../i18n.js';
    import { 
        approvalDecision,
    } from './diffStore.js';

    export let awaitingReview = false;

    const modalId = 'approvalModal';

    function rejectRequest() {
        approvalDecision.set(false);
        showModal();
    }

    function approveRequest() {
        approvalDecision.set(true);
        showModal();
    }
    
    function showModal() {
        jQuery(`#${modalId}`).modal('show');
    }
</script>

<a class="dropdown-item" on:click={rejectRequest} data-testid="reject-changes-button">
  <i class="fa fa-times" />
  {sgettext('$$REJECT_CHANGES$$')}
</a>

<a class="dropdown-item" on:click={approveRequest} data-testid={ awaitingReview ? "endorse-changes-button" : "approve-changes-button" }>
  <i class="fa fa-check" />
  {awaitingReview ? sgettext('$$ENDORSE_CHANGES$$') : sgettext('$$APPROVE_CHANGES$$')}
</a>
